import {Box} from '@mantine/core';
import Head from 'next/head';
import {useRouter} from 'next/router';
import type {FC} from 'react';
import {Declaration} from './Declaration';
import {PublicText} from './PublicText';

export const CorporatePrivacyPolicyPage: FC = () => {
  const router = useRouter();
  /*
   * ホスト名がlocalhostになっているため、OGPやSEOのURLを指定する要素に使えない.
   * 一旦ベタ書きで対応し、後に修正する.
   * todo URLのベタ書きを環境変数等から取得するように修正する.
   */
  const currentUrl = `https://gaishishukatsu.com/${decodeURI(router.pathname)}`;

  return (
    <>
      <Head>
        <title key="title">個人情報保護方針</title>
        <meta key="og:title" property="og:title" content="個人情報保護方針" />
        <meta key="og:url" property="og:url" content={currentUrl} />
        <link rel="canonical" href={currentUrl} key="canonical" />
      </Head>
      <Box className="w-full max-w-[664px]">
        <h1 className="hidden">個人情報保護方針</h1>
        <Declaration />
        <PublicText />
      </Box>
    </>
  );
};
